module.exports = __webpack_public_path__ + "img/d0c753ba1d55c2df448756016b66df4d.png";